export default __webpack_public_path__ + "static/media/che.562b25d6.svg";